import { FC, SVGProps } from 'react';

export const CheckIcon: FC<SVGProps<SVGSVGElement>> = props => (
	<svg xmlns='http://www.w3.org/2000/svg' width='9' height='7' viewBox='0 0 9 7' fill='none' {...props}>
		<path
			d='M0.970703 3.61435L3.37411 6.01776L8.18093 1.21094'
			stroke='currentColor'
			strokeWidth='1.60227'
			strokeLinecap='round'
			strokeLinejoin='round'
		/>
	</svg>
);
